import _ from 'lodash';
import EventBus from 'eventing-bus';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import 'react-accessible-accordion/dist/fancy-example.css';
import { deleteActivity } from '../../../../store/Activities/index';

const Actions = (props) => {
   const dispatch = useDispatch();

   let { activity } = props;
   const { currentWorkspace } = useSelector(state => state['Settings']);
   let { singlePageData, object } = useSelector(state => state['SinglePage']);
   let link = `${window['location']['origin']}/${currentWorkspace['_id']}/${object['type']}/${singlePageData['_id']}?tab=all&activityId=${activity['_id']}`;

   let [dropdowns, setDropdowns] = useState({});
   const toggleDropdownAction = (id) => setDropdowns((prev) => ({ ...prev, [id]: !prev[id] }));

   return (
      <Dropdown isOpen={dropdowns['actionsCall'] || false} toggle={() => toggleDropdownAction('actionsCall')} >
         <DropdownToggle caret>
            Actions
            <i className="icon">
               <svg width="5" height="4" viewBox="0 0 5 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.74219 2.40453L2.38875 0L0.385372 0C0.0425479 0 -0.128864 0.552327 0.113969 0.876105L1.96379 3.34253C2.26019 3.73773 2.74229 3.73773 3.03868 3.34253L3.74219 2.40453Z" fill="currentColor" />
                  <path d="M4.61365 0L2.38887 0L3.74231 2.40453L4.88863 0.876105C5.12789 0.552327 4.95648 0 4.61365 0Z" fill="currentColor" />
               </svg>
            </i>
         </DropdownToggle>
         <DropdownMenu>
            {/* <DropdownItem>Edit</DropdownItem> */}
            <DropdownItem>
               <CopyToClipboard text={link} onCopy={() => EventBus.publish('success', 'Link Copied!')}>
                  <a className="w-100 d-flex justify-content-between"><span>Copy link</span> <i className="fa fa-copy"></i></a>
               </CopyToClipboard>
            </DropdownItem>

            <DropdownItem onClick={() => dispatch(deleteActivity(activity['_id']))}>Delete</DropdownItem>
         </DropdownMenu>
      </Dropdown>
   )
}

export default Actions